(function(){
  var parts = window.TJAT100Parts || [];
  var meta = window.TJAT100Assemblies || {};
  var targetSku = 'YC.JG.ZS006786';
  var oldLgm1 = 'Spray-System Landing Gear — 1';
  var oldLgm2 = 'Spray-System Landing Gear — 2';
  var lgm1 = 'Landing Gear Module 1';
  var lgm2 = 'Landing Gear Module 2';
  function norm(v){ return String(v || '').trim().toUpperCase(); }

  parts.forEach(function(p){
    if (p.a === oldLgm1) p.a = lgm1;
    if (p.a === oldLgm2) p.a = lgm2;
  });
  if (meta[oldLgm1]) { meta[lgm1] = meta[oldLgm1]; delete meta[oldLgm1]; }
  if (meta[oldLgm2]) { meta[lgm2] = meta[oldLgm2]; delete meta[oldLgm2]; }

  for (var i = parts.length - 1; i >= 0; i--) {
    var p = parts[i];
    if (norm(p.m) === targetSku && p.a === lgm1 && (String(p.i) === '2' || String(p.i) === '6')) parts.splice(i,1);
  }

  function ensureShared(item){
    var exists = parts.some(function(p){
      return norm(p.m) === targetSku && p.g === 'spray' && p.a === lgm2 && String(p.i) === String(item);
    });
    if (exists) return;
    var insertAt = parts.length;
    for (var j = 0; j < parts.length; j++) {
      if (parts[j].g === 'spray' && parts[j].a === lgm2 && String(parts[j].i) === String(item)) insertAt = j + 1;
    }
    parts.splice(insertAt,0,{g:'spray',a:lgm2,i:String(item),m:targetSku,n:'Landing Gear Hose Clamp'});
  }

  ensureShared('2');
  ensureShared('6');

  /* Keep the Propellers browser rows aligned to the current recovered T100 manifest. */
  for (var k = parts.length - 1; k >= 0; k--) {
    if (parts[k] && parts[k].g === 'frame' && parts[k].a === 'Propellers') parts.splice(k,1);
  }
  [
    {g:'frame',a:'Propellers',i:'1',m:'YC.ST.LM000115',n:'Propeller Nut'},
    {g:'frame',a:'Propellers',i:'2',m:'YC.JG.QX004794',n:'Propeller Clamp'},
    {g:'frame',a:'Propellers',i:'3',m:'YC.JG.ZS008218',n:'Propeller Spacer'},
    {g:'frame',a:'Propellers',i:'4',m:'YC.JG.XW000291',n:'Propeller (CCW)'},
    {g:'frame',a:'Propellers',i:'5',m:'YC.JG.XW000292',n:'Propeller (CW)'},
    {g:'frame',a:'Propellers',i:'6',m:'BC.AG.SS001199',n:'Propeller Quick-Lock'},
    {g:'frame',a:'Propellers',i:'7',m:'YC.JG.MY002422',n:'Quick-Lock Cushion Pad'},
    {g:'frame',a:'Propellers',i:'8',m:'YC.WJ.L00868',n:'Frame / Propeller Clamp Screw M30-HC060060-55-85 V2'},
    {g:'frame',a:'Propellers',i:'9',m:'YC.JG.QX005333',n:'Quick-Lock Base'},
    {g:'frame',a:'Propellers',i:'10',m:'YC.ST.LL000705.02',n:'Quick-Lock Base Screw M40-HCT10100100-065030-5115-N'}
  ].forEach(function(row){ parts.push(row); });

  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var active = root.querySelector('.t100parts__system.is-active[data-group]');
    if (active) active.click();
  });
})();
